"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
// import getMD5 from 'js-md5'
var _default = exports.default = {
  methods: {
    /** 文件上传前钩子
     * @description: 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
     * @param { Object } file 待上传文件
     * @return { void }
     */
    beforeUpload: function beforeUpload(file) {
      var _this = this,
        _arguments = arguments;
      // console.log('beforeUpload', this.$refs['wl-upload']?.uploadFiles, { ...arguments })
      // 这里用方法是因为下边调用操作是异步，防止数据不更新
      var setOptions = function setOptions() {
        var _this$$attrs$data$nam, _this$$attrs$data, _this$$attrs$data$siz, _this$$attrs$data2;
        _this.defaultOptons.data.fileName = (_this$$attrs$data$nam = (_this$$attrs$data = _this.$attrs.data) === null || _this$$attrs$data === void 0 ? void 0 : _this$$attrs$data.name) !== null && _this$$attrs$data$nam !== void 0 ? _this$$attrs$data$nam : file.name;
        _this.defaultOptons.data.fileSize = (_this$$attrs$data$siz = (_this$$attrs$data2 = _this.$attrs.data) === null || _this$$attrs$data2 === void 0 ? void 0 : _this$$attrs$data2.size) !== null && _this$$attrs$data$siz !== void 0 ? _this$$attrs$data$siz : file.size;
      };

      /* 逐个上传，一个完到一个 */
      return new Promise(function (resolve, reject) {
        /* 上传状态 ture  允许上传 */
        if (_this.uploadRequestStatus) {
          // 立即变更上传状态，在前一个文件上传成功前阻止当前文件上传
          _this.uploadRequestStatus = false;
          // 处理上传参数
          setOptions();
          // 允许当前文件上传
          resolve();
        } else {
          // 60 * 100 次，计数器是10ms的  所以这里相当于限制 计数器时长为 60s
          var count = 60 * 100;
          var id = setInterval(function () {
            /* 如果计数器 超过60秒 或者 上传状态为 true 让当前文件上传 */
            if (!count-- || _this.uploadRequestStatus) {
              clearInterval(id);
              // 处理上传参数
              setOptions();
              // 允许当前文件上传
              resolve();
            }
          }, 10);
        }
        _this.$$listenersEmit.apply(_this, ['before-upload'].concat((0, _toConsumableArray2.default)(_arguments), [{
          resolve: resolve,
          reject: reject
        }]));
      });
    },
    /** 文件上传时的钩子
     * @description: 文件上传时的钩子
     * @param { Object } e 事件对象
     * @param { Object } file 上传的文件
     * @param { Array } fileList 上传的文件列表
     * @return { void }
     // */
    onProgress: function onProgress() {
      // console.log('onProgress', this.$refs['wl-upload']?.uploadFiles, { ...arguments })
      this.$$listenersEmit.apply(this, ['on-progress'].concat(Array.prototype.slice.call(arguments)));
    },
    /** 文件上传成功时的钩子
     * @description: 文件上传成功时的钩子
     * @param { Object } res response 请求响应
     * @param { Object } file 上传的文件
     * @param { Array } fileList 上传的文件列表
     * @return { void }
     */
    onSuccess: function onSuccess() {
      var _this$$refs$wlUpload;
      // console.log('onSuccess', this.$refs['wl-upload']?.uploadFiles, { ...arguments })
      this.uploadRequestStatus = true;
      this.$$listenersEmit.apply(this, ['on-success'].concat(Array.prototype.slice.call(arguments)));
      this.remove((_this$$refs$wlUpload = this.$refs['wl-upload']) === null || _this$$refs$wlUpload === void 0 ? void 0 : _this$$refs$wlUpload.uploadFiles);
    },
    /** 文件状态改变时的钩子
     * @description: 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
     * @param { Object } file 上传的文件
     * @param { Array } fileList 上传的文件列表
     * @return { void }
     */
    onChange: function onChange(file /* , fileList */) {
      var _res$data,
        _res$data$url$split,
        _res$data2,
        _this2 = this;
      // console.log('onChange', this.$refs['wl-upload']?.uploadFiles, { ...arguments })
      var res = file.response;

      /* 处理返回的图片地址数据，以免地址过长 */
      if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.url) res.data.url = ((_res$data$url$split = res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.url) === null || _res$data2 === void 0 ? void 0 : _res$data2.split('?')) !== null && _res$data$url$split !== void 0 ? _res$data$url$split : [])[0];
      /* 合并对象 */
      Object.assign(file, res === null || res === void 0 ? void 0 : res.data);
      if (this.isList) {
        var _this$files, _this$files2;
        var f2 = (_this$files = this.files) === null || _this$files === void 0 ? void 0 : _this$files.find(function (f) {
          return _this2.isEqual(f, file);
        });
        if (!f2) (_this$files2 = this.files) === null || _this$files2 === void 0 || _this$files2.push(file);
      } else {
        if (this.files) {
          var _this$files3;
          this.files.length = 0;
          (_this$files3 = this.files) === null || _this$files3 === void 0 || _this$files3.push(file);
        }
      }
      this.$$listenersEmit.apply(this, ['on-change'].concat(Array.prototype.slice.call(arguments)));
    },
    /** 删除文件
     * @description: 删除文件
     * @param { Object } file 文件
     * @param { Array } fileList 上传成功的文件列表
     * @return { void }
     */
    onRemove: function onRemove(file) {
      var _this3 = this;
      var arg = arguments;
      var delFile = function delFile() {
        var _this3$files, _this3$$refs$wlUploa, _this3$$refs$wlUploa2;
        var files = (_this3$files = _this3.files) !== null && _this3$files !== void 0 ? _this3$files : _this3.$refs['wl-upload'].uploadFiles;
        (_this3$$refs$wlUploa = _this3.$refs['wl-upload']) === null || _this3$$refs$wlUploa === void 0 || _this3$$refs$wlUploa.abort(file);
        var delId = null;
        files === null || files === void 0 || files.forEach(function (f, i) {
          return _this3.isEqual(f, file) && (delId = i);
        });
        delId !== null && ((_this3$$refs$wlUploa2 = _this3.$refs['wl-upload']) === null || _this3$$refs$wlUploa2 === void 0 || (_this3$$refs$wlUploa2 = _this3$$refs$wlUploa2.uploadFiles) === null || _this3$$refs$wlUploa2 === void 0 ? void 0 : _this3$$refs$wlUploa2.splice(delId, 1));
        _this3.uploadRequestStatus = true;
        _this3.$$listenersEmit.apply(_this3, ['on-remove'].concat((0, _toConsumableArray2.default)(arg)));
      };
      if (file.status === 'uploading') {
        this.$confirm('确定是否要删除当前文件', '当前文件正在上传！', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(delFile).catch(function () {
          return null;
        });
      } else delFile();
    },
    isEqual: function isEqual(a, b) {
      if (typeof a === 'string') return a === b.url;else if (this.$$dataTypeOf(a) === 'object') return b.uid && a.uid === b.uid || b.url && a.url === b.url;else return false;
    }
  }
};